export default {
  SET_NEW_USER(state, data) {
    state.newUser = data;
  },
  SET_USERS(state, data) {
    state.users = data;
  },
};
